<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-8 small-columns-12">
            <mat-label>{{ 'time-off-v3.workScheduleName' | translate }}</mat-label>
            <input
                name="workScheduleName"
                #workScheduleName="ngModel"
                placeholder="{{ 'time-off-v3.egFullTimeCanada' | translate }}"
                required
                [(ngModel)]="workSchedule.name"
                matInput
                type="text"
            />
            <mat-error *ngIf="workScheduleName.invalid">{{ workScheduleName.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
